module.exports = __webpack_public_path__ + "static/media/static.309b06de.png";